import { Link } from "react-router-dom";

import FieldHint from "./FieldHint";

/** Paso 4 · Comunicación: «¿Quieres administrar árbitros dentro de la
 * plataforma?» (maqueta Wiz-Arbitros-Opcion, Eduardo 2026-10-17). Con «No»
 * se esconde el botón Árbitros de la barra del torneo. */
interface Props {
  enabled: boolean;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
}

export default function RefereesOptionCard({ enabled, disabled = false, onChange }: Props) {
  function option(on: boolean, titulo: string, detalle: string) {
    const active = enabled === on;
    return (
      <label className={`aviso-radio${active ? " is-activa" : ""}`} data-referees-option={on ? "si" : "no"}>
        <input
          type="radio"
          name="arbitros-plataforma"
          checked={active}
          onChange={() => onChange(on)}
          disabled={disabled}
        />
        <strong>{titulo}</strong>
        <small>{detalle}</small>
      </label>
    );
  }

  return (
    <section className="card wiz-arbitros-card" data-wiz-card="arbitros">
      <header className="wiz-card__head">
        <h2>
          <span className="hint-label">
            Árbitros
            <span className="wiz-new-badge">Nuevo</span>
            <FieldHint label="¿Cómo funciona?">
              Das de alta a tus árbitros en Equipo (perfil Árbitro) y en la sección Árbitros del torneo asignas qué
              partido pita cada uno. El árbitro solo ve y captura sus partidos.
            </FieldHint>
          </span>
        </h2>
        <p>¿Quieres administrar árbitros dentro de la plataforma?</p>
      </header>
      <div className="aviso-radios" role="radiogroup" aria-label="Administrar árbitros">
        {option(false, "No", "El organizador captura los resultados")}
        {option(true, "Sí", "Asignas un árbitro a cada partido")}
      </div>
      {enabled ? (
        <p className="wiz-arbitros-card__ok" role="status">
          <span>✓ Se habilita el botón Árbitros en la barra del torneo</span>
          <Link to="/admin/team">Ir a Equipo ›</Link>
        </p>
      ) : null}
      <p className="wiz-arbitros-card__nota muted">
        Nota: los torneos que ya tienen árbitros asignados empiezan en «Sí».
      </p>
    </section>
  );
}
